import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

const ModalRechazarVerificacion = (props) => {
  const [rechazo, setRechazo] = useState("");
  const aceptarRechazo = () => {
    props.onHideAceptar(rechazo);
  };
  const cerrar = () => {
    props.onHideModal();
  };
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      size="lg"
      contentClassName="p-0 m-0"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setRechazo('')
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold text-light m-0">Motivo del Rechazo</h3>
        <button className="btn btn-sm bg-light" onClick={() => cerrar()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-between row">
        <div className="col-md-12 row mx-auto align-items-start">
          <div className="col-md-12 row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Motivo del Rechazo
              </span>
              <textarea
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="fecha"
                style={{
                  minHeight: "50px",
                }}
                value={rechazo}
                onChange={(e) => {
                  const { value } = e.target;
                  setRechazo(value);
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          style={{ margin: "2px" }}
          className="fw-bold btn btn-primary btn-sm rounded-pill"
          onClick={() => aceptarRechazo()}
        >
          <i className="fa fa-check"> Aceptar</i>
        </button>

        <button
          onClick={() => cerrar()}
          type="button"
          style={{ margin: "2px" }}
          className="fw-bold btn btn-danger btn-sm rounded-pill"
        >
          <i className="fa fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalRechazarVerificacion;
